var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useMemo, useState } from 'react';
import { IconEye } from '@/presentation/components/icons';
import { dateFormat } from '@/presentation/utils/parse-date';
import { useRecoilState } from 'recoil';
import { manageStudentsAtom } from '../components/atoms';
import { IconButton, TableItemStatus } from '@/presentation/components';
import useUserSesssion from '@/presentation/hooks/use-user-session';
import { mapToCardinal, toCardinal } from '@/presentation/functions/cardinal';
import { useNavigate } from 'react-router';
const UseManageStudents = (getClasses, getUsersPaginated, Styles, manageQuizzesUsers, managePreQuiz) => {
    const [state, setState] = useRecoilState(manageStudentsAtom);
    const [studentsWithExtraColumns, setStudentsWithExtraColumns] = useState([]);
    const { getIdClient, getClient } = useUserSesssion();
    const [allData, setAllData] = useState([]);
    const navigate = useNavigate();
    const client = getClient();
    useEffect(() => {
        getTeachersPaginated(state.filters);
    }, [
        state.filters.deleted,
        state.filters.input,
        state.filters.selectedClassId,
        state.filters.selectedGradeId,
        state.reloadStudents,
        state.modalCheckout
    ]);
    useEffect(() => {
        getClassesListData();
        getGradesListData();
        getTeachersPaginated(state.filters);
    }, []);
    const getTeachersPaginated = (filters, pagination = {
        pageIndex: 1,
        pageSize: 10
    }, sort) => __awaiter(void 0, void 0, void 0, function* () {
        changeLoading(true);
        console.log({
            filters
        });
        let statusIds = [];
        if (filters.deleted) {
            // statusIds = ['1', '2', '3', '4'];
            statusIds = ['4', '6'];
        }
        else {
            statusIds = ['1', '2', '3'];
        }
        let studentClassesIds = [];
        if (filters.selectedClassId && filters.selectedClassId !== '0') {
            studentClassesIds = [filters.selectedClassId];
        }
        const clientId = getIdClient();
        const filterProps = {
            rolesIds: ['11'],
            statusIds,
            studentClassesIds,
            input: filters.input,
            clientsIds: [clientId === null || clientId === void 0 ? void 0 : clientId.toString()],
            selectedGradeId: filters.selectedGradeId
        };
        const students = yield getUsersPaginated.getUsers(filterProps, sort, pagination);
        changeLoading(false);
        if (students && students.total > 0 && students.data.length > 0) {
            setStudentsWithExtraColumns(students);
            setState(prev => {
                return Object.assign(Object.assign({}, prev), { students: {
                        data: students.data,
                        count: students.count,
                        total: students.total,
                        page: students.page,
                        pageCount: students.pageCount
                    }, dataNotFound: false });
            });
        }
        else {
            setState(prev => {
                return Object.assign(Object.assign({}, prev), { students: {
                        data: [],
                        count: 0,
                        total: 0,
                        page: 0,
                        pageCount: 0
                    }, dataNotFound: true });
            });
        }
    });
    const getAllData = () => __awaiter(void 0, void 0, void 0, function* () {
        const filters = state === null || state === void 0 ? void 0 : state.filters;
        const clientId = getIdClient();
        changeLoading(true);
        let statusIds = [];
        if (filters.deleted) {
            statusIds = ['1', '2', '3', '4'];
        }
        else {
            statusIds = ['1', '2', '3'];
        }
        let studentClassesIds = [];
        if (filters.selectedClassId && filters.selectedClassId !== '0') {
            studentClassesIds = [filters.selectedClassId];
        }
        const filterProps = {
            rolesIds: ['11'],
            statusIds,
            studentClassesIds,
            clientsIds: [clientId === null || clientId === void 0 ? void 0 : clientId.toString()]
        };
        const students = yield getUsersPaginated.getAllUsers(filterProps);
        changeLoading(false);
        if (students && students.length > 0) {
            setState(prev => {
                return Object.assign(Object.assign({}, prev), { allStudents: students });
            });
            return students;
        }
        else {
            setAllData([]);
            return [];
        }
    });
    const changeLoading = (value) => {
        setState(prev => {
            return Object.assign(Object.assign({}, prev), { isTableLoading: value });
        });
    };
    const getClassesListData = () => __awaiter(void 0, void 0, void 0, function* () {
        const clientId = getIdClient();
        const classes = yield getClasses.getClasses({ clientsIds: [clientId === null || clientId === void 0 ? void 0 : clientId.toString()] });
        if (classes) {
            const classesData = classes === null || classes === void 0 ? void 0 : classes.map(element => {
                return {
                    key: `${element.id}`,
                    value: element.name
                };
            });
            classesData.unshift({ key: '0', value: 'All Classes' });
            setState(prev => {
                return Object.assign(Object.assign({}, prev), { classes: classesData });
            });
        }
    });
    const getGradesListData = () => {
        const grades = [3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
        if (grades) {
            const classesData = grades === null || grades === void 0 ? void 0 : grades.map(element => {
                return {
                    key: `${element}`,
                    value: toCardinal(element)
                };
            });
            classesData.unshift({ key: '0', value: 'All Grades' });
            setState(prev => {
                return Object.assign(Object.assign({}, prev), { grades: classesData });
            });
        }
    };
    const columnAlternativeNames = {
        createdAt: 'Date',
        title: 'Title',
        firstName: 'Name',
        email: 'Email',
        classesS: 'Class',
        grades: 'Grade',
        preQuiz: 'Pre-Quiz Avg. Score',
        cumulativeScore: 'Cumulative Score',
        status: 'Status',
        actions: 'View'
    };
    const columnsWithoutSort = ['actions'];
    const setColumnsByModel = () => {
        var _a;
        let keys = [];
        if ((client === null || client === void 0 ? void 0 : client.plan, (_a = client === null || client === void 0 ? void 0 : client.plan) === null || _a === void 0 ? void 0 : _a.includes('enterprise'))) {
            keys = [
                { id: 'createdAt', field: 'createdAt' },
                { id: 'firstName', field: 'firstName' },
                { id: 'email', field: 'email' },
                { id: 'classesS', field: 'classesS.name' },
                { id: 'grades', field: 'grades' },
                { id: 'preQuiz', field: 'preQuiz' },
                { id: 'cumulativeScore', field: 'cumulativeScore' },
                { id: 'status', field: 'userStatus.description' }
            ];
        }
        else {
            keys = [
                { id: 'createdAt', field: 'createdAt' },
                { id: 'firstName', field: 'firstName' },
                { id: 'email', field: 'email' },
                { id: 'grades', field: 'grades' },
                { id: 'preQuiz', field: 'preQuiz' },
                { id: 'cumulativeScore', field: 'cumulativeScore' },
                { id: 'status', field: 'userStatus.description' }
            ];
        }
        const columns = keys.map(key => {
            return Object.assign({ accessorFn: row => row[key.id], id: key.id, field: key.field, cell: info => info.getValue(), header: () => React.createElement("span", null, columnAlternativeNames[key.id]), enableSorting: !((key === null || key === void 0 ? void 0 : key.id) === 'preQuiz' || (key === null || key === void 0 ? void 0 : key.id) === 'cumulativeScore'), sortingFn: (key === null || key === void 0 ? void 0 : key.id) === 'preQuiz' || (key === null || key === void 0 ? void 0 : key.id) === 'cumulativeScore' ? '' : () => 0 }, getColumnSize(key));
        });
        columns.push(Object.assign({ accessorFn: row => row.actions, id: 'actions', cell: info => info.getValue(), header: () => React.createElement("span", null, columnAlternativeNames.actions), enableSorting: false, sortingFn: () => 0 }, sizeProps(10)));
        return columns;
    };
    const sizeProps = (size) => ({ size, maxSize: size, minSize: size });
    const getColumnSize = (key) => {
        switch (key) {
            case 'createdAt':
                return sizeProps(10);
            case 'firstName':
                return sizeProps(25);
            case 'email':
                return sizeProps(25);
            case 'classesS':
                return sizeProps(5);
            case 'grades':
                return sizeProps(5);
            case 'status':
                return sizeProps(5);
            default:
                return sizeProps(10);
        }
    };
    const columns = useMemo(() => [...setColumnsByModel()], []);
    const mapClasses = (classes) => {
        const classNames = classes === null || classes === void 0 ? void 0 : classes.map(item => {
            return item.name;
        });
        return classNames.join(', ');
    };
    const mapClassesGrade = (classes) => {
        const classNames = classes === null || classes === void 0 ? void 0 : classes.map(item => {
            var _a;
            return (_a = mapToCardinal(item === null || item === void 0 ? void 0 : item.grades)) === null || _a === void 0 ? void 0 : _a.join(', ');
        });
        return classNames === null || classNames === void 0 ? void 0 : classNames.join(', ');
    };
    const renderCellByType = (context, row) => {
        var _a, _b;
        const { column } = context;
        const parseStatus = (status) => {
            switch (status) {
                case 'Active':
                    return 'Active';
                case 'Deactive':
                    return 'Deactive';
                case 'Invited':
                    return 'Invited';
                case 'Draft':
                    return 'Draft';
                case 'Archived':
                    return 'Archived';
                default:
                    return 'Active';
            }
        };
        switch (column.id) {
            case 'createdAt':
                return React.createElement("div", null, dateFormat(row === null || row === void 0 ? void 0 : row.createdAt));
            case 'firstName':
                return React.createElement("span", null,
                    `${row === null || row === void 0 ? void 0 : row.firstName} ${row === null || row === void 0 ? void 0 : row.lastName}`,
                    " ");
            case 'email':
                return React.createElement("span", null, row === null || row === void 0 ? void 0 : row.email);
            case 'classesS':
                return React.createElement("span", null, mapClasses(row === null || row === void 0 ? void 0 : row.classesS));
            case 'grades':
                return React.createElement("span", null, mapClassesGrade(row === null || row === void 0 ? void 0 : row.classesS));
            case 'preQuiz':
                return React.createElement("span", null,
                    (row === null || row === void 0 ? void 0 : row.studentProgressPercentPreQuizz) || 0,
                    "%");
            case 'cumulativeScore':
                return React.createElement("span", null,
                    (row === null || row === void 0 ? void 0 : row.studentScorePercent) || 0,
                    "%");
            case 'status':
                return React.createElement(TableItemStatus, { text: (_a = row === null || row === void 0 ? void 0 : row.status) === null || _a === void 0 ? void 0 : _a.description, type: parseStatus((_b = row === null || row === void 0 ? void 0 : row.status) === null || _b === void 0 ? void 0 : _b.description) });
            case 'actions':
                return (React.createElement("div", { className: Styles.actionWrap },
                    React.createElement(IconButton, { className: Styles.icon, onClick: () => {
                            navigate(`/school-dashboard/manage-student/${row === null || row === void 0 ? void 0 : row.id}`);
                        } },
                        React.createElement(IconEye, { height: 32, width: 32, color: '#00A3FF' }))));
            default:
                return React.createElement("span", null);
        }
    };
    const mapDataForCSV = (dataToExport) => {
        try {
            if (dataToExport.length === 0)
                return [];
            const parseAddedAt = (date) => {
                try {
                    const dateObj = new Date(date);
                    const month = dateObj.toLocaleString('default', { month: 'long' });
                    const day = dateObj.getDate();
                    const year = dateObj.getFullYear();
                    return `${month} ${day}, ${year}`;
                }
                catch (error) {
                    console.error(error);
                    return date;
                }
            };
            if (dataToExport.length > 0) {
                return dataToExport === null || dataToExport === void 0 ? void 0 : dataToExport.map(item => {
                    var _a;
                    return ({
                        addedAt: parseAddedAt(item === null || item === void 0 ? void 0 : item.createdAt),
                        names: `${item === null || item === void 0 ? void 0 : item.firstName} ${item === null || item === void 0 ? void 0 : item.lastName}`,
                        email: item === null || item === void 0 ? void 0 : item.email,
                        class: mapClasses(item === null || item === void 0 ? void 0 : item.classesS),
                        grade: mapClassesGrade(item === null || item === void 0 ? void 0 : item.classesS),
                        preQuiz: `${(item === null || item === void 0 ? void 0 : item.preQuiz) || 0}%`,
                        cumulativeScore: `${(item === null || item === void 0 ? void 0 : item.cumulativeScore) || 0}%`,
                        status: (_a = item === null || item === void 0 ? void 0 : item.status) === null || _a === void 0 ? void 0 : _a.description
                    });
                });
            }
        }
        catch (error) {
            console.error(error);
        }
        return [];
    };
    return {
        columns,
        columnsWithoutSort,
        getTeachersPaginated,
        renderCellByType,
        mapDataForCSV,
        studentsWithExtraColumns,
        getAllData,
        allData
    };
};
export default UseManageStudents;
